export default __webpack_public_path__ + "static/media/page-v5-5.652e7cd8.png";